export default __webpack_public_path__ + "static/texture-yellow-dots-03-2a2d655f9d2588d2ee11d987fcddd1bc.png";